import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/styles/makeStyles";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const ReactSVGIcon = lazy(() =>
	import(/* webpackChunkName: "reactSVGIcon" */ "@micado-digital/react-svg-icon/ReactSVGIcon")
);

const useStyles = makeStyles(theme => ({
	hamburger: {
		alignItems: "center",
		color: theme.palette.secondary.main,
		justifyContent: "center"
	}
}));

const Hamburger = ({ isOpen, setOpen }) => {
	const theme = useTheme();
	const bigScreen = useMediaQuery(theme.breakpoints.up("md"));
	const css = useStyles();

	const toggleMenu = () => {
		setOpen(!isOpen);
	};

	return (
		<IconButton onClick={toggleMenu} aria-label="menu">
			<Suspense fallback={<></>}>
				<ReactSVGIcon
					className={css.hamburger}
					size={bigScreen ? 32 : 24}
					src={isOpen ? "/img/icons/close.svg" : "/img/icons/hamburger.svg"}
				/>
			</Suspense>
		</IconButton>
	);
};

Hamburger.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired
};

export default Hamburger;
